import JSONFields from './JSONFields';

export default JSONFields;
